module.exports = __webpack_public_path__ + "images/patterns/light/BrickHorizontal.0496dc05c7b746ffbd50.svg";